import React, { useState } from "react";
import { createStripeLoginLink } from "../../../../services/StripeServices";
import globalStyles from "../../../../styles/globalStyles.module.css";
import { useTranslation } from "react-i18next";

const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  useState(false);

  const handleCreateStripeLoginLink = async () => {
    const json = await createStripeLoginLink();
    const { url } = json;
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <button
      onClick={handleCreateStripeLoginLink}
      className={globalStyles.button}
    >
      {t("stripe.dashboard")}
    </button>
  );
};

export default Dashboard;
